<template>
  <gj-modal
      v-bind="$attrs"
      v-on="$listeners"
      :visible.sync="modalVisible"
      :confirm-loading="confirmLoading"
      size="auto"
      no-padding
      :content-style="{padding: '18px 80px 4px'}"
      @cancel="cancel"
      @confirm="confirm">
    <template #header>
      <span>{{title}}</span>
    </template>
    <template #content>
      <el-form
          ref="form"
          :model="form">
        <el-form-item
            prop="date"
            :rules="[
              { required: true, message: '请选择日期', trigger: ['change'] },
            ]">
          <gj-date-picker
              v-model="form.date"
              width="200px"
              :clearable="false"
              placeholder="请选择日期"
          ></gj-date-picker>
        </el-form-item>
      </el-form>
    </template>
  </gj-modal>
</template>

<script>
  import {formRuleMixin, modalMixIn} from "../../minxins";

  export default {
    name: "gj-date-picker-modal",
    mixins: [modalMixIn, formRuleMixin],
    props: {
      title: {
        default: '设置日期'
      },
      date: {
        default: null
      }
    },
    data() {
      return {
        form: {
          date: null
        }
      }
    },
    created() {
      this.form.date = this.date;
    },
    methods: {
      confirm() {
        if (this.$gjFormValidate()) {
          this.$emit('submit', this.form.date);
        }
      }
    }
  }
</script>

<style scoped>

</style>
